import { render, staticRenderFns } from "./products-list.vue?vue&type=template&id=ae4d9482&scoped=true&lang=pug&"
import script from "./products-list.vue?vue&type=script&lang=ts&"
export * from "./products-list.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae4d9482",
  null
  
)

export default component.exports